import { DatePicker, DatePickerProps, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { PickerValue } from "@mui/x-date-pickers/internals";
import { ForwardedRef, forwardRef, JSX, useEffect, useState } from "react";
import { isValid } from "date-fns";
import { Box, Typography, useTheme } from "@mui/material";

export interface DefaultDatePickerProps extends DatePickerProps {
    id?: string;
    showID?: boolean;
}

function DefaultDatePicker({
    value,
    onChange,
    ...props
}: DefaultDatePickerProps, ref?: ForwardedRef<HTMLDivElement>): JSX.Element   {
    const [valueBuffer, setValueBuffer] = useState<PickerValue>(value ?? null);
    const theme = useTheme();

    useEffect(() => {
        setValueBuffer(value ?? null);
    }, [value]);
    
    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box sx={{position: 'relative', width: '100%', paddingTop: '4px'}}>
                <DatePicker
                    ref={ref}
                    {...props}
                    value={valueBuffer}
                    onChange={(date, context) => {
                        if(isValid(date)){
                            setValueBuffer(date);
                            onChange?.(date, context);
                        }
                    }}
                />

                {props.showID && 
                    <Typography sx={{
                        color: theme.palette.primary.light,
                        position: 'absolute', 
                        fontSize: 'small',
                        top: '6px', 
                        right: '10px'
                    }}>{`[${props.id}]`}
                    </Typography>
                }
            </Box>            
        </LocalizationProvider>
    );
}

export default forwardRef(DefaultDatePicker);